import * as z from "zod";

export const CustomReportDraftStatusSchema = z.enum([
  "ready",
  "unavailable",
  "failed",
]);

/** The output fields every draft RPC returns, whatever its starting point. */
export const CustomReportDraftOutputShape = {
  status: CustomReportDraftStatusSchema,
  ast: z.unknown().nullable(),
  title: z.string().nullable(),
  explanation: z.string().nullable(),
  missingConcepts: z.array(z.string()),
  error: z.string().nullable(),
};

export const CustomReportDraftTeamIdSchema = z.string().trim().min(1);

export const CustomReportDraftMaxAttemptsSchema = z
  .number()
  .int()
  .min(1)
  .max(5);
